import { motion } from "framer-motion";
import { AlertTriangle, Brain, Scale, Target } from "lucide-react";

export const AnalysisReport = ({ report }) => {
  const blocks = [
    { icon: Brain, label: "Dominant signal", value: report?.dominant, tone: "positive" },
    { icon: AlertTriangle, label: "Main risk", value: report?.risk, tone: "magenta" },
    { icon: Scale, label: "Consensus spread", value: report?.disagreement, tone: "default" },
    { icon: Target, label: "Recommended action", value: report?.action, tone: "default" },
  ];

  return (
    <motion.div
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6, delay: 0.4 }}
      className="panel lg:col-span-5 flex flex-col"
      data-testid="analysis-report-card"
    >
      <div className="panel-header">
        <div className="flex items-center gap-2">
          <h3 className="font-display text-sm font-bold uppercase tracking-tight">
            Scheduled Analysis
          </h3>
          <span className="label-micro">/ Supabase</span>
        </div>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2">
        {blocks.map((b, idx) => {
          const Icon = b.icon;
          const tc =
            b.tone === "magenta"
              ? "text-magenta"
              : b.tone === "positive"
                ? "text-positive"
                : "text-foreground";
          return (
            <div
              key={idx}
              className={`p-4 border-b border-border ${idx % 2 === 0 ? "sm:border-r" : ""}`}
              data-testid={`report-block-${idx}`}
            >
              <div className="flex items-center gap-2 mb-2">
                <Icon className={`w-3.5 h-3.5 ${tc}`} />
                <span className="label-micro">{b.label}</span>
              </div>
              <div className={`text-sm font-mono leading-snug ${tc}`}>{b.value}</div>
            </div>
          );
        })}
      </div>

      <div className="p-4 text-[10px] uppercase tracking-[0.18em] text-text-secondary font-mono">
        From scheduled_analysis table. Not investment advice.
      </div>
    </motion.div>
  );
};

export default AnalysisReport;
